import BaseModel from './BaseModel'
import { ChannelFacility } from './ChannelFacility'
import LocationProduct from './LocationProduct'

/**
 * This Vuex ORM model represents rows in the parcs table. For other
 * PARCS-related API endpoints, see /services/api-clients/ParcsApi.ts.
 */
export default class SpotHeroFlexDiscount extends BaseModel {

  static entity = 'spothero_flex_discounts'
  static primaryKey = 'ID'

  declare ID: number
  declare locationProductID: number
  declare channelFacilityID: number
  declare discountType: string
  declare days: number
  declare percentage: number

  declare locationProduct: LocationProduct
  declare channelFacility: ChannelFacility

  static fields() {

    return {

      // fields
      ID: this.number(null),
      locationProductID: this.number(null),
      channelFacilityID: this.number(null),
      discountType: this.string(''),
      days: this.number(null),
      percentage: this.number(null),

      // relationships
      locationProduct: this.belongsTo(LocationProduct, 'locationProductID'),
      channelFacility: this.belongsTo(ChannelFacility, 'channelFacilityID'),

    }

  }

  /**
   * API methods
   */

  static fetchByLocationProductId(locationId: number, locationProductId: number): Promise<any> {

    return this.api().get(`/locations/${locationId}/location_products/${locationProductId}/spothero_flex_discounts`)

  }

  static patch(locationId: number, locationProductId: number, channelFacilityId: number, payload: PatchSpotHeroFlexDiscountsRequest): Promise<any> {

    const url = `/locations/${locationId}/location_products/${locationProductId}/spothero_flex_discounts/${channelFacilityId}`

    return this.api().patch(url, payload, {
      dataKey: 'spotheroFlexDiscounts',
    }).then(result => {
      this.query().delete(sfd => payload.deletes.includes((sfd as SpotHeroFlexDiscount).ID))
      return result
    })

  }

}

export interface PatchSpotHeroFlexDiscountsRequest {
  creates: PatchSpotHeroFlexDiscountsRequestCreate[]
  updates: PatchSpotHeroFlexDiscountsRequestUpdate[]
  deletes: number[]
}

interface PatchSpotHeroFlexDiscountsRequestCreate {
  discountType: string
  days: number
  percentage: number
}

interface PatchSpotHeroFlexDiscountsRequestUpdate {
  ID: number
  days: number
  percentage: number
}
